import { z } from 'zod';
import { paraBirimi } from '../nokta/nokta.js';
export const ortakNoktasi = z.object({
    ortakId: z.string(),
    noktaId: z.string(),
    noktaKod: z.string().nullable().optional(),
    noktaAd: z.string().nullable().optional(),
    komisyonYuzde: z.string().nullable().optional(),
});
export const ortak = z.object({
    id: z.string(),
    ad: z.string(),
    eposta: z.string().email(),
    telefon: z.string().nullable().optional(),
    iletisimAdSoyad: z.string().nullable().optional(),
    komisyonYuzde: z.string(),
    bankaIban: z.string().nullable().optional(),
    bankaAd: z.string().nullable().optional(),
    vergiNo: z.string().nullable().optional(),
    aktif: z.boolean(),
    olusturmaTarihi: z.string().datetime(),
    noktalar: z.array(ortakNoktasi).default([]),
});
export const ortakOlusturIstegi = z.object({
    ad: z.string().trim().min(2).max(120),
    eposta: z.string().email(),
    telefon: z.string().optional(),
    iletisimAdSoyad: z.string().optional(),
    komisyonYuzde: z
        .string()
        .regex(/^\d+(\.\d{1,2})?$/)
        .default('0'),
    bankaIban: z.string().optional(),
    bankaAd: z.string().optional(),
    vergiNo: z.string().optional(),
    aktif: z.boolean().default(true),
});
export const ortakGuncelleIstegi = ortakOlusturIstegi.partial();
export const noktaAtaIstegi = z.object({
    noktaIdler: z.array(z.string()).min(1),
    komisyonYuzde: z
        .string()
        .regex(/^\d+(\.\d{1,2})?$/)
        .optional(),
});
export const hakedisSorgusu = z.object({
    baslangic: z.string().datetime(),
    bitis: z.string().datetime(),
    ortakId: z.string().optional(),
});
export const hakedisRaporu = z.object({
    araliki: z.object({ baslangic: z.string().datetime(), bitis: z.string().datetime() }),
    ortaklar: z.array(z.object({
        ortakId: z.string(),
        ortakAd: z.string(),
        komisyonYuzde: z.string(),
        satirlar: z.array(z.object({
            noktaId: z.string(),
            noktaKod: z.string(),
            noktaAd: z.string(),
            paraBirimi,
            kiralamaSayisi: z.number().int(),
            brutGelir: z.string(),
            komisyonYuzde: z.string(),
            hakedis: z.string(),
        })),
        toplamHakedisTRY: z.string(),
    })),
});
//# sourceMappingURL=ortak.js.map